module.exports = "<nav class=\"navbar navbar-dark\">\r\n  <a class=\"navbar-brand\" href=\"./admin\"><img class=\"logo img-responsive\" src=\"{{icon}}\" alt=\"icon\" ></a>\r\n  <button class=\"btn btn-outline-info my-2 my-sm-0 button-logout\" routerLink=\"/logout\">Logout</button>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/topbar/topbar.component.html
// module id = ./src/app/components/admin/topbar/topbar.component.html
// module chunks = main